<template lang="pug">
shListData(title="Entregas" resolver="deliveries" keyData="delivery" component="shDelivery")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Deliveries',

  components: { shListData },

  mounted () {
    setTimeout(() => {
      this.$store.commit('assingDelivery')
      this.$store.commit('getData', { resolver: 'deliveries', key: 'delivery', page: 1 })
    }, 2000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/delivery/Deliveries.vue